import * as zod from 'zod';

import { checkMaskedLast4 } from '../cardNumber.ts';
import { checkLuhn } from '../checkLuhn.ts';

import { getMessage } from './localization/localization.ts';

export const createOptionalChecker = <T extends zod.ZodType<string>>(sc: T) =>
  sc.optional().or(zod.literal(''));

export const isNotEmpty = (message = getMessage('isNotEmpty')) => {
  return zod.string().trim().min(1, { message });
};

export const isEmail = (message = getMessage('isEmail')) => {
  return zod.string().email({ message });
};

export const checkNumberLength = (length: number, messageParam?: string) => {
  const message = messageParam ?? getMessage('checkNumberLength', { length });

  return zod.string().length(length, { message });
};

export const checkValidityOfLuhn = (
  message = getMessage('checkValidityOfLuhn'),
) => {
  return zod.string().refine(checkLuhn, { message });
};

export const checkValidityOfMaskedLast4 = () => {
  return zod.string().refine(checkMaskedLast4);
};

const checkExpireDate = (value: string) => {
  return /^\d{2}\/\d{2}$/.test(value);
};

export const checkValidityOfExpirationDate = (
  message = getMessage('checkValidityOfExpirationDate'),
) => {
  return zod.string().refine(checkExpireDate, { message });
};
